export default __webpack_public_path__ + "static/media/explore_destination_img2.e3624cf8.jpg";